query getAchievements {
  lpAchievements {
    achievements {
      baseAchievement {
        id
        name
        propsContent {
          id
          title
          type
          props
          images {
            id
          }
        }
      }
      currentAchievement {
        id
        name
        repeatable
        achievementLevel
        propsContent {
          id
          title
          type
          props
          images {
            id
          }
        }
        category {
          id
          name
        }
        userTask {
          id
          amount
          isCompleted
          target
          rewardClaimed
        }
        condition {
          id
          type
          hasProgressBar
          providersList {
            objId
            name
            code
          }
          gamesList {
            edges {
              node {
                gameId
                id
                name
                slug
                manufacturer {
                  code
                }
              }
            }
          }
          conditionSettings {
            id
            gameGroupFilter {
              id
              conditionId
              filterGames {
                type
                value
              }
            }
            quantitativeSettings {
              id
              amount1
              amount2
              amount3
              currency {
                code
                name
                objId
                region
              }
            }
            bettingFilters {
              id
              minOdd
              type
            }
          }
        }
        actions {
          id
          type
          freespinCount
          freespinSettings {
            freespinCount
            duration
            game {
              name
            }
            betByCurrency {
              betId
              denomination
            }
          }
          bettingBonusSettings {
            sumByUserCurrency
          }
          quantitativeSettings {
            id
            amount1
            amount2
            amount3
            currency {
              code
              name
              objId
              region
            }
          }
        }
      }
      nextAchievement
    }
    meta {
      total
      done
    }
  }
}
